import { render, staticRenderFns } from "./MoneyList.vue?vue&type=template&id=a8f4306a&scoped=true"
import script from "./MoneyList.vue?vue&type=script&lang=js"
export * from "./MoneyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f4306a",
  null
  
)

export default component.exports